module.exports = __webpack_public_path__ + "img/logoTrade.5d85f169.png";